import CONFIG from 'Config';
import { mapGetters } from 'vuex';

export default {
  watch: {
    isActiveMaintenance: {
      handler() {
        if (window.__prerender) return;
        if (this.$_maintenance_isActiveMaintenance && !this.$_maintenance_isOnMaintenancePage) window.location.pathname = '/maintenance';
      },
      immediate: true,
    },
  },
  beforeCreate() {
    if (window.__prerender) return;
    if (window.location.hash === '#super-user-on') {
      localStorage.setItem('active-super-user-AcreTrader', 'true');
      window.location.href = '/';
    } else if (window.location.hash === '#super-user-off') {
      localStorage.removeItem('active-super-user-AcreTrader');
      window.location.href = '/';
    }
  },
  computed: {
    ...mapGetters('router', [
      'isSuperUser',
    ]),
    $_maintenance_isActiveMaintenance() {
      return (CONFIG.isActiveMaintenanceMode && !this.isSuperUser);
    },
    $_maintenance_isOnMaintenancePage() {
      return this.$route.name === 'maintenance';
    },
  },
};
